import Column from '@components/Column';
import Loading from '@components/Loading';
import Row from '@components/Row';
import styled from '@emotion/styled';
import useItemCategories from '@hooks/category/useItemCategories';
import { Dispatch, SetStateAction, useContext } from 'react';

import ItemCategory from './ItemCategory';
import ItemFilters from './ItemFilters';
import ShopItemContext from '../../context/ShopItemContext';

function ItemCategories() {
    const { shopId } = useContext(ShopItemContext);
    const { categories, isLoading } = useItemCategories(shopId);
    return (
        <Column fullWidth>
            {isLoading && (<Loading size='small' />)}
            <Container spacing={8} fullWidth>
                <ItemFilters/>
                <ContentsRow spacing={8} >
                    {categories?.map((category) => (
                        <ItemCategory key={category.id}
                            categories={categories}
                            itemCategory={category}/>
                    ))}
                </ContentsRow>
            </Container>
        </Column>
    );
}

const Container = styled(Row)`
    max-width: 100%;
    //padding: 16px 14px 2px;
    padding: 16px 0 16px 20px;
    border-bottom: 1px solid var(--color-gray2);
`;

const ContentsRow = styled(Row)`
    flex: 1;
    overflow-x: auto;
    padding-right: 20px;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export default ItemCategories;
